import type { TedWordState } from "app/ted-word/tedWordState";
import {
  INITIAL_STATE,
  TedWordAction,
  tedWordReducer,
} from "app/ted-word/tedWordState";
import useResetableStorage, {
} from "app/utils/useResetableStorage";
import { createContext, useCallback, useContext, useReducer } from "react";

export function useTedWordReducer(storageKey: string) {
  const serializer = (state: TedWordState): string => JSON.stringify(state);
  const deserializer = (value: string): TedWordState => JSON.parse(value);

  const [savedState, setSaveState] = useResetableStorage(
    storageKey,
    INITIAL_STATE,
    { raw: false, serializer, deserializer },
  );

  const reducerLocalStorage = useCallback(
    (state: TedWordState, action: TedWordAction) => {
      const newState = tedWordReducer(state, action);
      setSaveState(newState);
      return newState;
    },
    [setSaveState],
  );

  return useReducer(reducerLocalStorage, savedState || INITIAL_STATE);
}

export const TedWordDispatchContext = createContext<
  React.Dispatch<TedWordAction>
>(() => {});

export function useTedWordActionDispatch() {
  return useContext(TedWordDispatchContext);
}

export const TedWordContext = createContext<TedWordState>(INITIAL_STATE);

export function useTedWordState() {
  return useContext(TedWordContext);
}
